import domReady from '@wordpress/dom-ready';

domReady(() => {
  const stickyLimit = 40;
  let sticky = 40;
  let timer = null;

  function updateNavbar() {
    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      // actual callback
      stickyNavbar();
    }, 50);
  }

  function stickyNavbar() {
    const st = window.scrollY;

    if (st >= sticky) {
      document.body.classList.add('sticky-navbar');
    } else {
      document.body.classList.remove('sticky-navbar');
    }

    if (document.body.classList.contains('home')) {
      if (st <= stickyLimit) {
        document.body.classList.add('transparent-navbar');
      } else {
        document.body.classList.remove('transparent-navbar');
      }
    }

    sticky = st + 40;
  }

  // Run on load
  updateNavbar();

  // Run on scroll
  window.addEventListener('scroll', updateNavbar);

  // Fix for Android Chrome where the browser URL bar covers position:fixed elements.
  if (window.visualViewport) {
    const navbar = document.querySelector('.navbar');

    function fixNavbarForVisualViewport() {
      if (!navbar) return;
      const offsetTop = window.visualViewport.offsetTop;
      navbar.style.top = offsetTop + 'px';
    }

    window.visualViewport.addEventListener(
      'resize',
      fixNavbarForVisualViewport
    );
    window.visualViewport.addEventListener(
      'scroll',
      fixNavbarForVisualViewport
    );
    fixNavbarForVisualViewport();
  }
});
